import { RequestData } from '@ant-design/pro-components';

import { request } from '@umijs/max';

import { DevicesRequest, FindDateRangeDevicesRequest, FindDateRangeDevicesResponse } from '@/types';

export async function getDevicesRequest(): Promise<RequestData<DevicesRequest>> {
  const data = await request<DevicesRequest[]>('devices', {
    method: 'GET',
  });
  return { data };
}

export async function getDevices(): Promise<DevicesRequest[]> {
  return request('devices', {
    method: 'GET',
  });
}

export async function findDateRangeDevices(payload: FindDateRangeDevicesRequest): Promise<FindDateRangeDevicesResponse[]> {
  return request('devices/findDateRangeDevices', {
    data: payload,
    method: 'POST',
  });
}
